import script from "./LoginDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginDialog.vue?vue&type=script&setup=true&lang=js"

import "./LoginDialog.vue?vue&type=style&index=0&id=597521f3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-597521f3"]])

export default __exports__